module.exports = __webpack_public_path__ + "static/media/ic_user_disabled.8c1fd4d5.png";